import { render, staticRenderFns } from "./NewProjectSearch.vue?vue&type=template&id=48ddd19b&scoped=true&"
import script from "./NewProjectSearch.vue?vue&type=script&lang=js&"
export * from "./NewProjectSearch.vue?vue&type=script&lang=js&"
import style0 from "./NewProjectSearch.vue?vue&type=style&index=0&id=48ddd19b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ddd19b",
  null
  
)

export default component.exports